/**
 * Định nghĩa các giá trị của các chức năng tại cột chức năng trên grid
 * NVTUAN1 26.07.2023
 */
export default {
  /**
   * Xem
   */
  View: 0,
  /**
   * Thêm
   */
  Insert: 1,
  /**
   * Sửa
   */
  Update: 2,
  /**
   * Xóa
   */
  Delete: 3,
  /**
   * Xóa custom
   */
  DeleteCustom: 4,
  /**
   * Không hiển thị
   */
  None: 5,
};
